import { createFileRoute } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";

export const Route = createFileRoute("/_default/contact-us")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <h1 className="mb-8 text-3xl font-bold">{t("contact_title")}</h1>

      <div className="space-y-6 text-gray-300">
        <p>{t("contact_intro_message")}</p>
        <p>{t("contact_support_message")}</p>
        <p className="text-gray-300">
          <Trans
            t={t}
            i18nKey="contact_email_message"
            components={{
              email: (
                <a
                  href="mailto:support@shorts-drama.com"
                  className="text-primary"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
}
